









































import { computed, defineComponent } from '@vue/composition-api';
import store from '@/store';
import Disclaimer from '@/components/Disclaimer.vue';
import { MPF_ABOUT_URL } from '@/environment';

export default defineComponent({
  name: 'HelpMenu',
  components: { Disclaimer },
  setup() {
    const showAnnotation = computed(() => store.getters.isScorerOrAnnotator);
    return { showAnnotation, MPF_ABOUT_URL };
  },
});
